module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_04-907f4f34b8f0609622d785164e5f3e7b.png";